// @flow

export const isIE11Win7 = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  return userAgent.indexOf('trident') >= 0 && userAgent.indexOf('windows nt 6.1') >= 0;
};
